import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "../ui/dialog";
import { Expand, X } from "lucide-react";
import { REFERENCES } from "../../data/content";
import { Reveal, Overline } from "./Reveal";

const spanFor = () => "";

export default function References() {
  const [active, setActive] = useState(null);

  return (
    <section id="referenciak" data-testid="references-section" className="scroll-mt-24 bg-slate-50 py-16 sm:py-20 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <div className="max-w-2xl mb-14">
          <Reveal><Overline>Referenciák</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 text-4xl sm:text-5xl font-bold tracking-tight text-[#0E5A75] text-balance">
              Elkészült munkáink
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-4 text-base text-slate-600 leading-relaxed max-w-xl">
              Néhány elkészült tetőfedési, felújítási és bádogos munkánk. Kattintson a képekre a
              nagyobb nézethez.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-5">
          {REFERENCES.map((r, i) => (
            <Reveal key={i} delay={(i % 4) * 0.06} className={spanFor(i)}>
              <button
                data-testid={`reference-${i}`}
                onClick={() => setActive(r)}
                className="group relative aspect-[4/3] h-full w-full overflow-hidden rounded-2xl border border-slate-200 bg-slate-200 shadow-sm hover:shadow-xl transition-shadow"
              >
                <img src={r.src} alt={r.label} loading="lazy" className="h-full w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0E5A75]/85 via-[#0E5A75]/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <span className="absolute left-3.5 bottom-3.5 flex items-center gap-2 text-left text-sm font-semibold text-white translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
                  <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-[#0E5A75]"><Expand className="h-4 w-4" /></span>
                  Nagyítás
                </span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent data-testid="reference-lightbox" className="max-w-4xl border-0 bg-transparent p-0 shadow-none [&>button]:hidden">
          {active && (
            <div className="relative">
              <DialogTitle className="sr-only">{active.label}</DialogTitle>
              <img src={active.src} alt={active.label} className="max-h-[82vh] w-full rounded-2xl object-contain" />
              <div className="absolute left-4 bottom-4 rounded-full bg-[#0E5A75]/85 px-4 py-2 text-sm font-semibold text-white backdrop-blur">
                {active.label}
              </div>
              <button
                data-testid="lightbox-close"
                onClick={() => setActive(null)}
                className="absolute -top-3 -right-3 flex h-10 w-10 items-center justify-center rounded-full bg-white text-[#0E5A75] shadow-lg"
                aria-label="Bezárás"
              >
                <X className="h-5 w-5" />
              </button>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
}
